import { Injectable } from '@angular/core';

import { UserService } from './user/user.service';

@Injectable()
export class EmailService {
  constructor(private userService: UserService) {}

  send(subject: string, ...addresses: string[]): void {
    if (window) {
      window.location.href = `mailto://${addresses.join(';')}?subject=${subject}`;
    }
  }

  sendToPms(subject: string): void {
    this.userService.listPMs().subscribe(infoList => {
      this.send(subject, ...infoList.map(info => info.emailAddress));
    });
  }
}

